export function selectUserId(state) {
  return state.auth.userId;
}
